export default "__VITE_ASSET__C6Td1M5Q__"